import { HTMLAttributes } from 'react';
import { Icon, IconName } from '../Graphics';
import { StepperStatus } from '../../enums';
import { joinClassNames } from '../../utils';
import styles from './styles.module.scss';

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  status: StepperStatus;
  stepNumber: number;
};

export const Badge = ({ status, stepNumber }: BadgeProps) => (
  <span
    className={joinClassNames(
      styles.stepperItemBadge,
      status === StepperStatus.Completed && styles.completed
    )}
  >
    {status === StepperStatus.Completed ? <Icon name={IconName.Check} size="0.65em" /> : stepNumber}
  </span>
);
